var bluebox4i = function(){
	var forms = new forms4i(),
	friendAddyDialog,
	editAddyDialog,
	
	init = function(){
    		if(document.getElementById("yesBox")){ //index page - changed this from otherBox to yesBox for COVID
    			document.getElementById('disabledMessage').classList.add('hide'); // javascript message
    			var otherBox = document.getElementById("otherBox");
			document.getElementById("cancelAddressChange").addEventListener("click", formEvents.CancelEdit);	
			document.getElementById("closeAddressChange").addEventListener("click", formEvents.CancelEdit);
			document.getElementById("yesBox").addEventListener("click", function(e){
				e.preventDefault();
				ajaxActions.SendBox();
				omniture.LogButtonClick("yesBox");
			});
			if (otherBox) {
				document.getElementById("otherBox").addEventListener("click", formEvents.OtherBox); 
				document.getElementById("cancelBoxSuggestion").addEventListener("click", formEvents.CancelSuggestion);
				document.getElementById('submitSuggestion').addEventListener("click", function(e){
					e.preventDefault();
					formEvents.SubmitSuggestion();
					omniture.LogButtonClick("submitSuggestion");
				});
				if (document.getElementById("altBoxOptions")) {
					document.getElementById("requestCustomBox").addEventListener("click", formEvents.ShowSuggestion);
					document.getElementById("cancelAltBox").addEventListener("click", formEvents.CancelAltBox);
					document.getElementById("acceptAltBox").addEventListener("click", function (e){
						e.preventDefault();
						forms.formValidation(document.getElementById("altBoxes"), formEvents.SubmitAltBox(), e);
						omniture.LogButtonClick("acceptAltBox");
					});
				}
			}
			document.getElementById('saveAddressChange').addEventListener("click", function(e){
				e.preventDefault();
	    			forms.formValidation(document.getElementById("editAddress"), ajaxActions.ChangeAddress, e); 
	    		});
    			document.getElementById("yesBox").disabled = false;  // button is initially disabled to prevent people from clicking it before js attached event listener
    		}
    		var noBox = document.getElementById("NoBox");
		if(noBox) {
			noBox.addEventListener("click", function(e){
				e.preventDefault();
				ajaxActions.NoThanks();
				omniture.LogButtonClick("NoBox");
			});
		}
		if (document.getElementById("trendingProducts")) {
    			var productScroller = new prodScroller();
    			productScroller.InitSliderLessItems("trendingProducts");
    		}
    		
    		if(document.getElementById('editAddress')){
			editAddyDialog = new dialog4i();
			var editModal = document.getElementById('editAddress');
			var editAddyTrigger = document.getElementById("editAddressLink");
			editAddyDialog.init(editModal, editAddyTrigger);
		}
		
		if(document.getElementById('friendAddress')){
			friendAddyDialog = new dialog4i();
			var friendModal = document.getElementById('friendAddress');
			var friendAddyTrigger = document.getElementById("yesFriendBox");
			friendAddyDialog.init(friendModal, friendAddyTrigger);
		}
	},	
	shareBoxEvents = function(){	
		document.getElementById("blueBoxButtons").classList.add("hide");
        	document.getElementById("addressInfo").classList.add("hide");
		document.getElementById("shareableBoxForm").classList.remove("hide");
		/*document.getElementById("yesFriendBox").addEventListener("click", function(e) {
			e.preventDefault();
			formEvents.SendToFriend(e);
		});*/
		
		document.getElementById('acceptFriendBox').addEventListener("click", function(e){
			e.preventDefault();
			forms.formValidation(document.getElementById("friendAddress"), ajaxActions.AcceptFriendBox, e);
		});
		document.getElementById('noFriendBox').addEventListener("click", function(e){
			e.preventDefault();
			ajaxActions.DeclineFriendBox(e);
		});
		document.getElementById('cancelFriendBox').addEventListener("click", function(e){
			e.preventDefault();
			formEvents.CancelSendToFriend(e);
		});
		document.getElementById('closeFriendAddress').addEventListener("click", function(e){
			e.preventDefault();
			formEvents.CancelSendToFriend(e);
		});
	},
	formEvents = (function(){
		 /*var editAddress = function(e){
		 	e.preventDefault();
		 	document.getElementById("editAddressLink").setAttribute("aria-expanded", "true");
		 	editAddyDialog.open();
		},*/
		var changeAddressDisplay = function(){
			var successMsg = '<p class="addySuccess textsemibold text16 marginTop5 textDarkestGray displayFlex flexNoWrap flexAlignItemsCenter" role="alert" aria-atomic="true"><svg class="textDarkestGray" height="20px" width="20px" role="img" aria-hidden="true"> <use xlink:href="#svgIcon-checkMark"></use> </svg> Address updated</p>';

			var company = document.getElementById("Company") ? document.getElementById("Company").value : "";
			var addr1 = document.getElementById("Address1") ? document.getElementById("Address1").value : "";
			var addr2 = document.getElementById("Address2") ? document.getElementById("Address2").value : "";
			var addr3 = document.getElementById("Address3") ? document.getElementById("Address3").value : "";
			var city = document.getElementById("City") ? document.getElementById("City").value : "";
			var state = document.getElementById("State") ? document.getElementById("State").value : "";
			var zipcode = document.getElementById("Zipcode") ? document.getElementById("Zipcode").value : "";
			
			var companyDisplay = document.getElementById("companyDisplay");
			var addr1Display = document.getElementById("addr1Display");
			var addr2Display = document.getElementById("addr2Display");
			var addr3Display = document.getElementById("addr3Display");
			var cityDisplay = document.getElementById("cityDisplay");
			var stateDisplay = document.getElementById("stateDisplay");
			var zipcodeDisplay = document.getElementById("zipcodeDisplay");
			
			if(document.querySelector(".addySuccess")){
				document.querySelector(".addySuccess").parentNode.removeChild(document.querySelector(".addySuccess"));
			}
			if (companyDisplay) {
				if (company.trim() == "") {
					companyDisplay.classList.add("hide");
				}
				else {
					companyDisplay.classList.remove("hide");
					companyDisplay.innerHTML = company;
				}
			}
			if (addr1Display && addr1.trim() != "") {
				addr1Display.innerHTML = addr1;
			}
			if (addr2Display) {
				if (addr2.trim() == "") {
					addr2Display.classList.add("hide");
				}
				else {
					addr2Display.classList.remove("hide");
					addr2Display.innerHTML = addr2;
				}
			}
			if (addr3Display) {
				if (addr3.trim() == "") {
					addr3Display.classList.add("hide");
				}
				else {
					addr3Display.classList.remove("hide");
					addr3Display.innerHTML = addr3;
				}
			}
			if (cityDisplay && city.trim() != "") {
				cityDisplay.innerHTML = city;
			}
			if (stateDisplay) {
				if (state.trim() == "") {
					stateDisplay.classList.add("hide");
				}
				else {
					stateDisplay.classList.remove("hide");
					stateDisplay.innerHTML = state;
				}
			}
			if (zipcodeDisplay && zipcode.trim() != "") {
				zipcodeDisplay.innerHTML = zipcode;
			}
			
			var resultCompanyDisplay = document.getElementById("resultCompanyDisplay");
			var resultAddr1Display = document.getElementById("resultAddr1Display");
			var resultAddr2Display = document.getElementById("resultAddr2Display");
			var resultAddr3Display = document.getElementById("resultAddr3Display");
			var resultCityDisplay = document.getElementById("resultCityDisplay");
			var resultStateDisplay = document.getElementById("resultStateDisplay");
			var resultZipcodeDisplay = document.getElementById("resultZipcodeDisplay");
			
			if (resultCompanyDisplay) {
				if (company.trim() == "") {
					resultCompanyDisplay.classList.add("hide");
				}
				else {
					resultCompanyDisplay.classList.remove("hide");
					resultCompanyDisplay.innerHTML = company;
				}
			}
			if (resultAddr1Display && addr1.trim() != "") {
				resultAddr1Display.innerHTML = addr1;
			}
			if (resultAddr2Display) {
				if (addr2.trim() == "") {
					resultAddr2Display.classList.add("hide");
				}
				else {
					resultAddr2Display.classList.remove("hide");
					resultAddr2Display.innerHTML = addr2;
				}
			}
			if (resultAddr3Display) {
				if (addr3.trim() == "") {
					resultAddr3Display.classList.add("hide");
				}
				else {
					resultAddr3Display.classList.remove("hide");
					resultAddr3Display.innerHTML = addr3;
				}
			}
			if (resultCityDisplay && city.trim() != "") {
				resultCityDisplay.innerHTML = city;
			}
			if (resultStateDisplay) {
				if (state.trim() == "") {
					resultStateDisplay.classList.add("hide");
				}
				else {
					resultStateDisplay.classList.remove("hide");
					resultStateDisplay.innerHTML = state;
				}
			}
			if (resultZipcodeDisplay && zipcode.trim() != "") {
				resultZipcodeDisplay.innerHTML = zipcode;
			}
						
			editAddyDialog.close();			
			document.getElementById("editAddressLink").setAttribute("aria-expanded", "false");
	        	document.getElementById("editAddressLink").focus();
	        	document.getElementById("editAddressLink").insertAdjacentHTML("afterend", successMsg);
		},
		cancelEdit = function(e){
			e.preventDefault();
	        	resetInvalidFields();
	        	editAddyDialog.close();
	        	document.getElementById("editAddressLink").setAttribute("aria-expanded", "false");
	        	document.getElementById("editAddressLink").focus();
		},
		resetInvalidFields = function(){
			var invalidFields = [].slice.call(document.querySelectorAll(".input-validation-error"));
	        	invalidFields.forEach(function(el, index, array){
	        		el.classList.remove("input-validation-error");
	        		el.setAttribute("aria-invalid", "false");
	        	});
	        	var errorMessages = document.getElementsByClassName("errorMessage");
	        	for (let i = 0; i < errorMessages.length; i++) {
	        		errorMessages[i].classList.add("hide");
	        	}
	        	if(document.getElementById("ErrorBox")){
	        		document.getElementById("ErrorBox").parentNode.removeChild(document.getElementById("ErrorBox"));
	        	}
	        	if (document.getElementById("editAddressError")) {
	        		document.getElementById("editAddressError").innerHTML = "";
	        	}
		},
		showSuggestion = function(e) {
			e.preventDefault();
			resetInvalidFields();
			var altBoxOptions = document.getElementById("altBoxOptions");
			if (altBoxOptions) {
				altBoxOptions.classList.add("opaque");
				document.getElementById("altBoxButtons").classList.add("hide");
				var altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
				if (altBoxRadioButtons) {
					for (let i = 0; i < altBoxRadioButtons.length; i++) {
						altBoxRadioButtons[i].disabled = true;
					}
				}
			}
			var boxSuggestion = document.getElementById("boxSuggestion");
			boxSuggestion.classList.add("fadeIn");
			boxSuggestion.classList.remove("hide");
	        	document.getElementById("bbSuggestion").focus();
		},
		cancelSuggestion = function(e){
			e.preventDefault();
			document.getElementById("boxSuggestion").classList.add("hide");
	        	resetInvalidFields();
			var altBoxOptions = document.getElementById("altBoxOptions");
			if (altBoxOptions) {
				altBoxOptions.classList.remove("opaque");
				document.getElementById("altBoxButtons").classList.remove("hide");
				var altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
				if (altBoxRadioButtons) {
					var i;
					for (i = 0; i < altBoxRadioButtons.length; i++) {
						altBoxRadioButtons[i].disabled = false;
					}
					//altBoxRadioButtons[0].focus();
					document.getElementById("requestCustomBox").focus();
				}
			}
			else {
				document.getElementById("bbProducts").classList.remove("opaque");
		        	document.getElementById("blueBoxButtons").classList.remove("hide");
		        	document.getElementById("otherBox").focus();
	        	}
		},
		submitSuggestion = function(){
			if (document.getElementById('bbSuggestion').value == "") {
	           	 	document.getElementById('bbSuggestion').classList.add("input-validation-error");
	            		document.getElementById('bbSuggestion').setAttribute("aria-invalid", "true");
	            		document.getElementById('suggestionError').classList.remove("hide");
	            		document.getElementById('bbSuggestion').focus();
	        	}else {
	            		document.getElementById('bbSuggestion').classList.remove("input-validation-error");
	            		document.getElementById('bbSuggestion').setAttribute("aria-invalid", "false");
	            		document.getElementById('suggestionError').classList.add("hide");
	            		ajaxActions.BbSuggestion();
	        	}
		},
		otherBox = function(e){
			e.preventDefault();
			removeStatusMsg();
	        	if(document.getElementById("chooseSize")){
	        		document.getElementById("chooseSize").style.display = "none";
	        	}
	        	document.getElementById("bbProducts").classList.add("opaque");
	        	document.getElementById("blueBoxButtons").classList.add("hide");
			var altBoxes = document.getElementById("altBoxes");
			if (altBoxes) {
				altBoxes.classList.add("fadeIn");
				altBoxes.classList.remove("hide");
				document.getElementById("AltBoxesSeen").value = "true";
				var altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
				if (altBoxRadioButtons) {
					document.getElementById("altBoxOptions").querySelector("a").focus();
					//altBoxRadioButtons[0].focus();
				}
			}
			else {
				showSuggestion(e);
			}
		},
		submitAltBox = function() {
			var altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
			var altBoxChosen = 0;
                    	for (let i = 0; i < altBoxRadioButtons.length; i++){
                    		if (altBoxRadioButtons[i].checked)
                    			altBoxChosen = altBoxRadioButtons[i].value;
                    	}
                    	
			if (altBoxChosen < 1) {
	            		document.getElementById('altBoxError').classList.remove("hide");
	            		altBoxRadioButtons[0].focus();
	        	}else {
	            		document.getElementById('altBoxError').classList.add("hide");
	            		ajaxActions.AcceptAltBox(altBoxChosen);
	        	}
		},
		cancelAltBox = function(e) {
			e.preventDefault();
			document.getElementById("altBoxes").classList.add("hide");
	        	resetInvalidFields();
	        	document.getElementById("bbProducts").classList.remove("opaque");
	        	document.getElementById("blueBoxButtons").classList.remove("hide");
	        	document.getElementById("otherBox").focus();
		},
	    	/*sendToFriend = function(e){
			e.preventDefault();
			document.getElementById("yesFriendBox").setAttribute("aria-expanded", "true");
			friendAddyDialog.open();
		},*/
		cancelSendToFriend = function(e){
			e.preventDefault();
	        	resetInvalidFields();
	        	//friendAddyDialog.close();
	        	//document.getElementById("yesFriendBox").setAttribute("aria-expanded", "false");
	        	//document.getElementById("yesFriendBox").focus();
		},
		addFriendAddressDisplay = function(){
			var friendFirstName = document.getElementById("FriendFirstName") ? document.getElementById("FriendFirstName").value : "";
			var friendLastName = document.getElementById("FriendLastName") ? document.getElementById("FriendLastName").value : "";
			var friendName = friendFirstName + " " + friendLastName;
			var friendCompany = document.getElementById("FriendCompany") ? document.getElementById("FriendCompany").value : "";
			var friendAddr1 = document.getElementById("FriendAddress1") ? document.getElementById("FriendAddress1").value : "";
			var friendAddr2 = document.getElementById("FriendAddress2") ? document.getElementById("FriendAddress2").value : "";
			var friendAddr3 = document.getElementById("FriendAddress3") ? document.getElementById("FriendAddress3").value : "";
			var friendCity = document.getElementById("FriendCity") ? document.getElementById("FriendCity").value : "";
			var friendState = document.getElementById("FriendState") ? document.getElementById("FriendState").value : "";
			var friendZipcode = document.getElementById("FriendZipcode") ? document.getElementById("FriendZipcode").value : "";
			var friendMessage = document.getElementById("FriendMessage") ? document.getElementById("FriendMessage").value : "";
			
			var friendNameDisplay = document.getElementById("resultFriendName");
			var friendCompanyDisplay = document.getElementById("resultFriendCompany");
			var friendAddr1Display = document.getElementById("resultFriendAddr1");
			var friendAddr2Display = document.getElementById("resultFriendAddr2");
			var friendAddr3Display = document.getElementById("resultFriendAddr3");
			var friendCityDisplay = document.getElementById("resultFriendCity");
			var friendStateDisplay = document.getElementById("resultFriendState");
			var friendZipcodeDisplay = document.getElementById("resultFriendZipcode");
			var friendMessageDisplay = document.getElementById("resultFriendMessage");
			var friendMessageContainer = document.getElementById("resultFriendMessageContainer");
			
			if (friendNameDisplay && friendName.trim() != "") {
				friendNameDisplay.innerHTML = friendName;
			}
			if (friendCompanyDisplay) {
				if (friendCompany.trim() == "") {
					friendCompanyDisplay.classList.add("hide");
				}
				else {
					friendCompanyDisplay.innerHTML = friendCompany;
				}
			}
			if (friendAddr1Display && friendAddr1.trim() != "") {
				friendAddr1Display.innerHTML = friendAddr1;
			}
			if (friendAddr2Display) {
				if (friendAddr2.trim() == "") {
					friendAddr2Display.classList.add("hide");
				}
				else {
					friendAddr2Display.innerHTML = friendAddr2;
				}
			}
			if (friendAddr3Display) {
				if (friendAddr3.trim() == "") {
					friendAddr3Display.classList.add("hide");
				}
				else {
					friendAddr3Display.innerHTML = friendAddr3;
				}
			}
			if (friendCityDisplay && friendCity.trim() != "") {
				friendCityDisplay.innerHTML = friendCity;
			}
			if (friendStateDisplay) {
				if (friendState.trim() == "") {
					friendStateDisplay.classList.add("hide");
				}
				else {
					friendStateDisplay.innerHTML = friendState;
				}
			}
			if (friendZipcodeDisplay && friendZipcode.trim() != "") {
				friendZipcodeDisplay.innerHTML = friendZipcode;
			}
			if (friendMessageDisplay && friendMessage.trim() != "") {
				friendMessageDisplay.innerHTML = friendMessage;
				friendMessageContainer.classList.remove("hide");
			}
			
			document.getElementById("resultFriendAddressInfo").classList.remove("hide");
		},
		removeStatusMsg = function(){
			if(document.getElementById("bbStatus")){
				document.getElementById("bbStatus").parentNode.removeChild(document.getElementById("bbStatus"));
			}
		},
		displayFormSections = function(response) {
			if (document.getElementsByClassName("mainForm")[0])
				document.getElementsByClassName("mainForm")[0].classList.add("hide");
				
			if (response.model.Result != null && response.model.Result != "" && document.getElementsByClassName("boxResult")[0]) {
				document.getElementsByClassName("boxResult")[0].classList.remove("hide");
				document.getElementsByClassName("clickErrorMessage")[0].classList.add("hide");
				if (response.model.Result == "accepted" || response.model.Result == "declinedFriend") {
					document.getElementsByClassName("accepted")[0].classList.remove("hide");
					document.getElementById("resultAddressInfo").classList.remove("hide");
					updateA11yStatus("Thank you, your Blue Box is on the way.");
				}
				else if (response.model.Result == "acceptedFriend") {
					document.getElementsByClassName("accepted")[0].classList.remove("hide");
					document.getElementsByClassName("acceptedFriend")[0].classList.remove("hide");
					document.getElementById("resultAddressInfo").classList.remove("hide");
					updateA11yStatus("Thank you, your Blue Box is on the way.");
				}
				else if (response.model.Result == "suggested") {
					document.getElementsByClassName("suggested")[0].classList.remove("hide");
					updateA11yStatus("Thank you for your feedback.");
				}
				else if (response.model.Result == "declined") {
					document.getElementsByClassName("declined")[0].classList.remove("hide");
					updateA11yStatus("Your Blue Box has been skipped.");
				}
			}
			else if ((response.model.Result == null || response.model.Result == "") && response.model.ShareableBoxID == 0) {
				document.getElementsByClassName("boxResult")[0].classList.remove("hide");
				document.getElementsByClassName("clickErrorMessage")[0].classList.remove("hide");
			}
			
			if (response.model.HeaderMessage != null && response.model.HeaderMessage.trim() != "")
				document.querySelector(".bbHeaderText h1").innerHTML = response.model.HeaderMessage;
						
			window.scrollTo({
				top: 0, 
				behavior: "smooth" 
			});
			
			// find first link in this section that isn't hidden and set focus for a11y
			var firstLink = getVisibleLink(document.querySelector(".submitResults"));
			console.log(firstLink);
			firstLink.focus();
		},
		updateA11yStatus = function(text){
			if(document.querySelector(".submitStatus")){
				document.querySelector(".submitStatus").parentNode.removeChild(document.querySelector(".submitStatus"));
			}
			var status = '<p class="submitStatus visually-hidden" role="alert" aria-atomic="true">' + text + '</p>';
			document.querySelector(".submitResults").insertAdjacentHTML("afterbegin", status);
		},
		getVisibleLink = function(section){
			var visibleLinks = [];
			var allLinks = section.querySelectorAll("a");
			for(var i = 0; i < allLinks.length; i++){
				if(allLinks[i].offsetParent !== null){
					visibleLinks.push(allLinks[i]);
				}
			}
			return visibleLinks[0];
		},
		displayStatusMsg = function(){
			document.getElementById("bbHeader").insertAdjacentHTML("afterend", '<div id="bbStatus" class="c-md-5 c-sm-quarter-3 c-xs-full"><p class="inlineMiddle marginTop20 padding15 textRed textSemiBold text16 borderDkRed" role="status">We were unable to process your request. Please refresh the page and try again.</p></div>');
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		},
		displayCookieStatusMsg = function () {
			document.getElementById("bbHeader").insertAdjacentHTML("afterend", '<div id="bbStatus" class="c-md-5 c-sm-quarter-3 c-xs-full"><p class="inlineMiddle marginTop20 padding15 textRed textSemiBold text16 borderDkRed" role="status">We were unable to process your request. Please refresh the page and try again. If you continue to receive this message, please be sure you have cookies enabled and no extensions or browser settings are blocking the use of cookies.</p></div>');
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		};
		
		 return{
		 	//EditAddress: editAddress,
		 	ChangeAddressDisplay: changeAddressDisplay,
		 	CancelEdit: cancelEdit,
		 	ShowSuggestion: showSuggestion,
		 	CancelSuggestion: cancelSuggestion,
		 	SubmitSuggestion: submitSuggestion,
		 	OtherBox: otherBox,
		 	SubmitAltBox: submitAltBox,
		 	CancelAltBox: cancelAltBox,
		 	//SendToFriend: sendToFriend,
		 	CancelSendToFriend: cancelSendToFriend,
		 	AddFriendAddressDisplay: addFriendAddressDisplay,
		 	RemoveStatusMsg: removeStatusMsg,
		 	DisplayStatusMsg: displayStatusMsg,
		 	DisplayCookieStatusMsg: displayCookieStatusMsg,
		 	DisplayFormSections: displayFormSections
		 };
	})(),

    	ajaxActions = (function(){ 
		var header = { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "" },
		headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "",
		
		oBoxModel = {
			FirstName: document.getElementById("FirstName") ? document.getElementById("FirstName").value : "",
			LastName: document.getElementById("LastName") ? document.getElementById("LastName").value : "", 
			Company: document.getElementById("Company") ? document.getElementById("Company").value : "", 
			Address1: document.getElementById("Address1") ? document.getElementById("Address1").value : "",
			Address2: document.getElementById("Address2") ? document.getElementById("Address2").value : "", 
			Address3: document.getElementById("Address3") ? document.getElementById("Address3").value : "", 
			City: document.getElementById("City") ? document.getElementById("City").value : "",
			State: document.getElementById("State") ? document.getElementById("State").value : "",
			ZipCode: document.getElementById("Zipcode") ? document.getElementById("Zipcode").value : "",
			BoxID: document.getElementById("BoxID") ? document.getElementById("BoxID").value : "",
			EndDate: document.getElementById("EndDate") ? document.getElementById("EndDate").value : "",
			CampaignID: document.getElementById("CampaignID") ? document.getElementById("CampaignID").value : "",
			CustomerContactID: document.getElementById("CustomerContactID") ? document.getElementById("CustomerContactID").value : "",
			CustomerID: document.getElementById("CustomerID") ? document.getElementById("CustomerID").value : ""
		},
		disableBlueBtn = function(btn){
			btn.disabled = true;
			btn.classList.remove("bkgdBlue");
			btn.classList.add("bkgdLtGray");
			btn.classList.add("textDarkestGray");
		},
		enableBlueBtn = function(btn){
			btn.disabled = false;
			btn.classList.add("bkgdBlue");
			btn.classList.remove("bkgdLtGray");
			btn.classList.remove("textDarkestGray");
		},
		getAltBoxIDs = function(){
			var altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
			if (altBoxRadioButtons) {
				oBoxModel.AltBoxOptions = [];
				for (let i = 0; i < altBoxRadioButtons.length; i++) {
					oBoxModel.AltBoxOptions.push({ "BoxID" : altBoxRadioButtons[i].value });
				}
			}
		},
		sendBox = function(){
			document.getElementById("blueBoxYesLoad").classList.remove("hide");			
			if (document.getElementById("yesBox")) {
				disableBlueBtn(document.getElementById("yesBox"));
			}			
			formEvents.RemoveStatusMsg();	
			
			if (!document.cookie) {
				formEvents.DisplayCookieStatusMsg();
                    }
                    
                    oBoxModel.AltBoxesSeen = document.getElementById("AltBoxesSeen") ? document.getElementById("AltBoxesSeen").value : "false";
                    	if (oBoxModel.AltBoxesSeen == "true") {
                    		getAltBoxIDs();
                    	}
                                        
			fetch('/bluebox/AcceptBox', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(oBoxModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if (response.model.ShareableBoxID > 0) {
					document.getElementById("ShareableBoxID").value = response.model.ShareableBoxID;
					document.getElementById("yesBox").setAttribute("aria-expanded", "true");
					shareBoxEvents();
				}
				else {
					formEvents.DisplayFormSections(response);
				}
				if (document.getElementById("yesBox")) {
					enableBlueBtn(document.getElementById("yesBox"));
				}
			}).catch(function(error){
				document.getElementById("blueBoxYesLoad").classList.add("hide");				
				formEvents.DisplayStatusMsg();
				if (document.getElementById("yesBox")) {
					enableBlueBtn(document.getElementById("yesBox"));
				}
			});
		},
		
		noThanks = function(){
			document.getElementById("blueBoxNoLoad").classList.remove("hide");
			formEvents.RemoveStatusMsg();
			
			oBoxModel.AltBoxesSeen = document.getElementById("AltBoxesSeen") ? document.getElementById("AltBoxesSeen").value : "false";
			if (oBoxModel.AltBoxesSeen == "true") {
                    		getAltBoxIDs();
                    	}
			
			fetch('/bluebox/DeclineBox', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(oBoxModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				formEvents.DisplayFormSections(response);
			}).catch(function(error){
				document.getElementById("blueBoxNoLoad").classList.add("hide");				
				formEvents.DisplayStatusMsg();
			});
		},
		
		bbSuggestion = function(){
			document.getElementById("submittingSuggestion").classList.remove("hide");
			disableBlueBtn(document.getElementById("submitSuggestion"));
			formEvents.RemoveStatusMsg();
			oBoxModel.CampaignID = document.getElementById("CampaignID") ? document.getElementById("CampaignID").value : "";
			oBoxModel.CustomerContactID =document.getElementById("CustomerContactID") ? document.getElementById("CustomerContactID").value : "";
			oBoxModel.CustomerID =document.getElementById("CustomerID") ? document.getElementById("CustomerID").value : "";
			oBoxModel.Suggestion = document.getElementById("bbSuggestion") ? document.getElementById("bbSuggestion").value : "";
			
			oBoxModel.AltBoxesSeen = document.getElementById("AltBoxesSeen") ? document.getElementById("AltBoxesSeen").value : "false";
			if (oBoxModel.AltBoxesSeen == "true") {
                    		getAltBoxIDs();
                    	}
			
			fetch('/bluebox/BoxSuggestion', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(oBoxModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				formEvents.DisplayFormSections(response);
				enableBlueBtn(document.getElementById("submitSuggestion"));
			}).catch(function(error){
				document.getElementById("submittingSuggestion").classList.add("hide");
				formEvents.DisplayStatusMsg();
				enableBlueBtn(document.getElementById("submitSuggestion"));
			});
		},
		
		changeAddress = function(){
			document.getElementById("submitChangeAddress").classList.remove("hide");
			if (document.getElementById("saveAddressChange")) {
				disableBlueBtn(document.getElementById("saveAddressChange"));
			}
			
			oBoxModel.Company = document.getElementById("Company") ? document.getElementById("Company").value : "";
			oBoxModel.Address1 = document.getElementById("Address1") ? document.getElementById("Address1").value : "";
			oBoxModel.Address2 = document.getElementById("Address2") ? document.getElementById("Address2").value : ""; 
			oBoxModel.Address3 = document.getElementById("Address3") ? document.getElementById("Address3").value : "";
			oBoxModel.City = document.getElementById("City") ? document.getElementById("City").value : "";
			oBoxModel.State = document.getElementById("State") ? document.getElementById("State").value : "";
			oBoxModel.ZipCode = document.getElementById("Zipcode") ? document.getElementById("Zipcode").value : "";
			
			fetch('/bluebox/EditAddress', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(oBoxModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if (response.success) {
					formEvents.ChangeAddressDisplay();
				}
				else {
					document.getElementById("editAddressError").innerHTML = "<div class=\"errorMessage text16 textDkRed textsemibold marginBtm10\" role=\"alert\">Your delivery address could not be changed. Please try again later.</div>";
				}
				document.getElementById("submitChangeAddress").classList.add("hide");
				if (document.getElementById("saveAddressChange")) {
					enableBlueBtn(document.getElementById("saveAddressChange"));
				}
			}).catch(function(error){
				document.getElementById("submitChangeAddress").classList.add("hide");
				formEvents.DisplayStatusMsg();
				if (document.getElementById("saveAddressChange")) {
					enableBlueBtn(document.getElementById("saveAddressChange"));
				}
			});
		},
	
		declineFriendBox = function(e){
			document.getElementById("noFriendBoxLoad").classList.remove("hide");
			formEvents.RemoveStatusMsg();
			
			fetch('/bluebox/DeclineFriendBox', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(oBoxModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				formEvents.DisplayFormSections(response);
			}).catch(function(error){
				document.getElementById("noFriendBoxLoad").classList.add("hide");
				formEvents.DisplayStatusMsg();
			});	
		},
	
		acceptFriendBox = function(){
			document.getElementById("acceptFriendBoxLoad").classList.remove("hide");
			disableBlueBtn(document.getElementById("acceptFriendBox"));
			formEvents.RemoveStatusMsg();
			oBoxModel.FriendFirstName = document.getElementById("FriendFirstName") ? document.getElementById("FriendFirstName").value : "";
               	oBoxModel.FriendLastName = document.getElementById("FriendLastName") ? document.getElementById("FriendLastName").value : "";
    			oBoxModel.FriendCompany = document.getElementById("FriendCompany") ? document.getElementById("FriendCompany").value : "";
               	oBoxModel.FriendCity = document.getElementById("FriendCity") ? document.getElementById("FriendCity").value : "";
           		oBoxModel.FriendState = document.getElementById("FriendState") ? document.getElementById("FriendState").value : "";
             		oBoxModel.FriendZipCode = document.getElementById("FriendZipcode") ? document.getElementById("FriendZipcode").value : "";
              	oBoxModel.FriendAddress1 = document.getElementById("FriendAddress1") ? document.getElementById("FriendAddress1").value : "";
			oBoxModel.FriendAddress2 = document.getElementById("FriendAddress2") ? document.getElementById("FriendAddress2").value : "";
			oBoxModel.FriendAddress3 = document.getElementById("FriendAddress3") ? document.getElementById("FriendAddress3").value : "";
			oBoxModel.FriendMessage = document.getElementById("FriendMessage") ? document.getElementById("FriendMessage").value : "";
			oBoxModel.ShareableBoxID = document.getElementById("ShareableBoxID") ? document.getElementById("ShareableBoxID").value : "";
			
			fetch('/bluebox/AcceptFriendBox', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(oBoxModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				formEvents.AddFriendAddressDisplay();
				formEvents.DisplayFormSections(response);
				enableBlueBtn(document.getElementById("acceptFriendBox"));
				if (response.friendBox) {
					document.getElementsByClassName("errorMsg1")[0].classList.add("hide");
					document.getElementsByClassName("errorMsg5")[0].classList.remove("hide");
				}
			}).catch(function(error){
				document.getElementById("acceptFriendBoxLoad").classList.add("hide");
				formEvents.DisplayStatusMsg();
				enableBlueBtn(document.getElementById("acceptFriendBox"));
			});		
		},
		
		acceptAltBox = function(altBoxChosen){
			document.getElementById("altBoxLoad").classList.remove("hide");			
			if (document.getElementById("acceptAltBox")) {
				disableBlueBtn(document.getElementById("acceptAltBox"));
			}			
			formEvents.RemoveStatusMsg();
			
			if (!document.cookie) {
				formEvents.DisplayCookieStatusMsg();
                    }
                    
                    	oBoxModel.AltBoxChosen = altBoxChosen;
                    	oBoxModel.AltBoxesSeen = "true";
            		getAltBoxIDs();
                    
			fetch('/bluebox/AcceptAltBox', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(oBoxModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if (document.getElementById("resultMainBoxProducts")) {
					document.getElementById("resultMainBoxProducts").classList.add("hide");
				}
				var resultAltBoxProducts = document.getElementById("resultAltBoxProducts" + altBoxChosen);
				if (resultAltBoxProducts) {
					resultAltBoxProducts.classList.remove("hide");
				}
				formEvents.DisplayFormSections(response);
				if (document.getElementById("acceptAltBox")) {
					enableBlueBtn(document.getElementById("acceptAltBox"));
				}
			}).catch(function(error){
				document.getElementById("altBoxLoad").classList.add("hide");				
				formEvents.DisplayStatusMsg();
				if (document.getElementById("acceptAltBox")) {
					enableBlueBtn(document.getElementById("acceptAltBox"));
				}
			});
		};
 		
    		return{
    			SendBox: sendBox,
    			NoThanks: noThanks,
    			BbSuggestion: bbSuggestion,
    			ChangeAddress: changeAddress,
    			DeclineFriendBox: declineFriendBox,
    			AcceptFriendBox: acceptFriendBox,
    			AcceptAltBox: acceptAltBox
    		};
    	})(),
    	
    	omniture = (function () {
    		var logButtonClick = function(buttonID) {
    			try {
				var s=s_gi('4imprintprod'); 
				s.linkTrackVars = 'eVar27,events';
				s.linkTrackEvents = 'event24';
				s.eVar27 = buttonID;
				s.events = 'event24'; 
				s.tl(this, 'o', 'Bluebox Links');  
			} 
			catch (error) {
			}
		};
		
		return {
			LogButtonClick: logButtonClick
		};
	})();
    	
	return{
		Init: init
	};
};


(function(){
	var blueBox = new bluebox4i();
	blueBox.Init();
})();